import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

export enum WebViewerPausedModalType {
  START,
  RESUME,
}

@Component({
  selector: 'app-web-viewer-performance-pause-modal',
  templateUrl: './web-viewer-performance-pause-modal.component.html',
  styleUrls: ['./web-viewer-performance-pause-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class WebViewerPerformancePauseModalComponent {
  @Input() modalType = WebViewerPausedModalType.RESUME;
  @Output() startOrResumeWebViewer = new EventEmitter<void>();
  protected readonly WebViewerPausedModalType = WebViewerPausedModalType;

  constructor(private translateService: TranslateService) {}

  get messageText(): string {
    switch (this.modalType) {
      case WebViewerPausedModalType.START:
        return this.translateService.instant(
          'Due to performance issues on your device, this app needs to be started manually. To interact with this app, tap ‘Start’.',
        );
      case WebViewerPausedModalType.RESUME:
        return this.translateService.instant(
          'Due to performance issues on your device, this app is temporarily paused. Tap ‘Resume’ to interact with this app. ',
        );
    }
  }

  get buttonText(): string {
    switch (this.modalType) {
      case WebViewerPausedModalType.START:
        return this.translateService.instant('Start');
      case WebViewerPausedModalType.RESUME:
        return this.translateService.instant('Resume');
    }
  }

  get highlightedText(): string {
    return `‘${this.buttonText}’`;
  }

  buttonClickHandler() {
    this.startOrResumeWebViewer.emit();
  }
}
